import { render } from "./SurveyRevisions.vue?vue&type=template&id=9b2e08dc"
import script from "./SurveyRevisions.vue?vue&type=script&lang=js"
export * from "./SurveyRevisions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__